<template>
  <section class="myhome-con"
           v-if="isInit">
    <div class="tit-box type1">
      <h1 class="tit-type1">기본정보</h1>
      <div>
        <!-- //todo 현재는 기본 정보 변경 숨김 -->
        <btn style="display: none;"
             :txt="'변경'"
             :size="'small'"
             :color="'white'"
             @click="btnBsInfoChng_click"/>
      </div>
    </div>
    <table class="tb-row">
      <colgroup>
        <col style="width:20%;"/>
        <col style="width:auto;"/>
        <col style="width:20%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>시설명</th>
        <td>{{ fcltyNm }}</td>
        <th>사업자등록번호</th>
        <td class="last">{{ $cmmn.txt.getBznoFormat(bzno) }}</td>
      </tr>
      <tr>
        <th>대표자명</th>
        <td colspan="3"
            class="last"
            style="line-height: 25px;">
          {{ rpstvNm }}
        </td>
      </tr>
      <tr>
        <th>사업자등록증</th>
        <td colspan="3"
            class="last"
            style="line-height: 25px;">
          <a href="javascript:;"
             @click="fileDwld_click">{{ bzlcFile.orgnFlnm }}</a>
        </td>
      </tr>
      <tr>
        <th>유형</th>
        <td colspan="3" class="last">{{ fcltyTynm }} / {{ fcltyDpTynm }}</td>
      </tr>
      </tbody>
    </table>
    <div class="info-txt-bottom mgt5">
      <ul class="info1 depth1">
        <li>시설기본정보 변경은 고객센터(1577-7522)로 연락해주시기 바랍니다.</li>
      </ul>
    </div>
    <div class="tit-box type1">
      <h1 class="tit-type1">상세정보</h1>
      <btn :txt="'변경'"
           :size="'small'"
           :color="'white'"
           @click="btnAditInfoChng_click"/>
    </div>
    <table class="tb-row">
      <colgroup>
        <col style="width:20%;"/>
        <col style="width:auto;"/>
        <col style="width:20%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>주소</th>
        <td colspan="3" class="last">( {{zip}} ) {{ fcltyAddr }} {{ fcltyDpAddr }}</td>
      </tr>
      <tr>
        <th>전화번호</th>
        <td>{{ fcltyTlno }}</td>
        <th>팩스</th>
        <td class="last">{{ fcltyFaxTlno }}</td>
      </tr>
      <tr>
        <th>업태</th>
        <td>{{ bizcndNm }}</td>
        <th>종목</th>
        <td class="last">{{ itemNm }}</td>
      </tr>
      <tr>
        <th>시설이메일</th>
        <td colspan="3" class="last">{{ taxbilRcpnEmail }}</td>
      </tr>
      <tr>
        <th>시설핸드폰번호</th>
        <td colspan="3" class="last">{{ fcltyMbpnTlno }}</td>
      </tr>
      </tbody>
    </table>
  </section>
</template>

<script setup>
import FcltyBsInfoChngRqt from '@/views/my-home/fclty-bs-info-chng-rqt.vue';
import FcltyAditInfoChng from '@/views/my-home/fclty-adit-info-chng.vue';
import {defineProps, onMounted, ref} from "vue";
import {getStore, getUtils} from "@/utils/import";

const {$popup, $axios, $cmmn, $alert, $file} = getUtils();
const {$loading} = getStore();

const props = defineProps({
  fcltySn: {
    type: Number,
    required: true,
  }
});

const getFcltyByFcltySn = async () => {
  const data = await $cmmn.fclty.getFcltyByFcltySn(props.fcltySn);
  fcltyNm.value = data.fcltyNm;
  fcltyTycd.value = data.fcltyTycd;
  fcltyTynm.value = data.fcltyTynm;
  fcltyDpTycd.value = data.fcltyDpTycd;
  fcltyDpTynm.value = data.fcltyDpTynm;
  rpstvNm.value = data.rpstvNm;
  bzno.value = data.bzno;
  zip.value = data.zip;
  fcltyAddr.value = data.fcltyAddr;
  fcltyDpAddr.value = data.fcltyDpAddr;
  fcltyTlno.value = data.fcltyTlno;
  fcltyFaxTlno.value = data.fcltyFaxTlno;
  fcltyMbpnTlno.value = data.fcltyMbpnTlno;
  bizcndNm.value = data.bizcndNm;
  itemNm.value = data.itemNm;
  taxbilRcpnEmail.value = data.taxbilRcpnEmail;

  const fileSn = data.bzlcFileSn;
  if (fileSn) bzlcFile.value = await $file.getFileByFileSn(fileSn);
}

const fileDwld_click = async () => {
  try {
    $loading.on();

    const {ncpObjectNm, orgnFlnm} = bzlcFile.value;

    await $file.ncp.tcfl.dwld(ncpObjectNm, orgnFlnm);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

/* 시설기본정보 */
const fcltyNm = ref('');
const rpstvNm = ref('');
const bzno = ref('');
const bzlcFile = ref({});
const btnBsInfoChng_click = async () => {
  try {
    $loading.on();

    const isPsbl = await getIsBsChngRqtPsbl();
    if (!isPsbl) {
      await $alert('이미 요청하신 내역이 있습니다.');
      return false;
    }

    openBsInfoPopup();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const getIsBsChngRqtPsbl = async () => {
  const {data} = await $axios.get('/api/fclty/is-bs-chng-rqt-psbl', {params: {fcltySn: props.fcltySn}});
  return data;
}

const openBsInfoPopup = () => {
  const popupOpts = {
    header: '시설기본정보 변경 요청',
    contentStyle: {
      'width': '550px'
    },
  }
  const emits = {'rqt-compt': getFcltyByFcltySn};

  $popup.show(FcltyBsInfoChngRqt, popupOpts, props, emits);
}

/* 시설추가정보 */
const fcltyTycd = ref('');
const fcltyTynm = ref('');
const fcltyDpTycd = ref('');
const fcltyDpTynm = ref('');
const zip = ref('');
const fcltyAddr = ref('');
const fcltyDpAddr = ref('');
const fcltyTlno = ref('');
const fcltyFaxTlno = ref('');
const fcltyMbpnTlno = ref('');
const bizcndNm = ref('');
const itemNm = ref('');
const taxbilRcpnEmail = ref('');

const btnAditInfoChng_click = () => {
  const popupOpts = {
    header: '시설추가정보 변경',
    contentStyle: {
      'width': '900px'
    },
  }

  const emits = {'chng-compt': getFcltyByFcltySn};

  $popup.show(FcltyAditInfoChng, popupOpts, props, emits);
}

const isInit = ref(false);
onMounted(async () => {
  try {
    $loading.on();

    await getFcltyByFcltySn();

    isInit.value = true;
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
